import { AbstractApiService } from "../abstractions/AbstractApiService";
import { OnRequestSuccess, OnRequestError } from "./Responses";

export class ClientStateService extends AbstractApiService {
    constructor() {
        super();
    }

    public SaveState(stateValue: any, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        let jsonStateValue = JSON.stringify(stateValue);
        this.Post('api/clientstate/save', jsonStateValue, onSuccess, onError);
    }

    public GetState(onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/clientstate/get', onSuccess, onError);
    }
}


// WEBPACK FOOTER //
// ./src/services/ClientStateService.tsx